/**
 * Export layout modes.
 *
 * @author    Naotoshi Fujita
 * @copyright Naotoshi Fujita. All rights reserved.
 */

/**
 * Enumerate slides from left to right.
 *
 * @type {string}
 */
export const LTR = 'ltr';

/**
 * Enumerate slides from right to left.
 *
 * @type {string}
 */
export const RTL = 'rtl';

/**
 * Enumerate slides in a col.
 *
 * @type {string}
 */
export const TTB = 'ttb';